// extracted by mini-css-extract-plugin
export default {"highlight":"useMagneticWallSheetContext-module__highlight--oj06Z","image":"useMagneticWallSheetContext-module__image--cmBSZ"};